import React from 'react';
import _sharedStylesRaw from './ClubShared.module.css';
const sharedStyles = (typeof _sharedStylesRaw === 'object' && _sharedStylesRaw !== null) ? _sharedStylesRaw : {};
import styles from './ClubArticles.module.css';
import OptimizedImage from '../player/OptimizedImage';

export default function ClubArticles({ articles, isLoading }) {
    if (!isLoading && (!articles || articles.length === 0)) {
        return (
            <section className={styles.articlesSection}>
                <h2 className={sharedStyles.sectionTitle}>Articles</h2>
                <p style={{ color: '#8d8d8d', fontSize: '14px' }}>No stories found.</p>
            </section>
        );
    }

    return (
        <section className={styles.articlesSection}>
            <h2 className={sharedStyles.sectionTitle}>Articles</h2>
            <div className={styles.articleGrid}>
                {isLoading ? (
                    Array.from({ length: 6 }).map((_, i) => (
                        <div key={`skeleton-${i}`} className={styles.skeletonCard}>
                            <div className={styles.skeletonThumbnail} />
                            <div className={styles.skeletonTextWrapper}>
                                <div className={styles.skeletonText} />
                                <div className={styles.skeletonText} />
                                <div className={styles.skeletonText} />
                                <div className={styles.skeletonText} />
                            </div>
                        </div>
                    ))
                ) : (
                    articles.map((article) => {
                        const { category, headline, date, url, thumbnail, id } = article;

                        return (
                            <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={id}
                                className={styles.articleCard}
                            >
                                <div className={styles.imageWrapper}>
                                    <OptimizedImage src={thumbnail} alt="" width={150} height={150} unoptimized className={styles.thumbnail} />
                                </div>
                                <div className={styles.articleInfo}>
                                    <span className={styles.categoryBadge}>{category}</span>
                                    <h3 className={styles.articleTitle}>{headline}</h3>
                                    <time className={styles.date}>{date}</time>
                                </div>
                            </a>
                        );
                    })
                )}
            </div>
        </section>
    );
}
